import React from 'react';
import { SYSTEM_ICON_SIZES } from '../../constants';
import { getStrokeColor } from '../../utils';
import type { SystemIconType } from '../../types';
import { pascalToSnake } from '../../../utils';

const EyeSlashIcon = ({
  size = 'sm',
  color = 'currentColor',
  dataTrackTag = pascalToSnake('EyeSlashIcon'),
}: SystemIconType) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={SYSTEM_ICON_SIZES[size]}
    height={SYSTEM_ICON_SIZES[size]}
    fill="none"
    viewBox="0 0 16 17"
    data-track-tag={dataTrackTag}
  >
    <path
      stroke={getStrokeColor(color)}
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.5}
      d="M13.4 10.525c1.055-.972 1.35-2.025 1.35-2.025C13.738 6.475 11.165 3.775 8 3.775m3.375 8.382c-.968.62-2.106 1.068-3.375 1.068-3.165 0-5.737-2.7-6.75-4.725 0 0 1.013-2.025 3.037-3.43m2.267 2.08A1.977 1.977 0 1 0 9.35 9.946M1.925 2.425l12.15 12.15"
      vectorEffect="non-scaling-stroke"
    />
  </svg>
);
EyeSlashIcon.id = 'EyeSlashIcon';
EyeSlashIcon.displayName = 'EyeSlashIcon';
export default EyeSlashIcon;
